<template>
	<div class="c-datetime">
		<el-date-picker v-model="valueData" :type="compType" :placeholder="placeholder" :value-format="format" :picker-options="pickerOptions" @focus="focusHandle"></el-date-picker>
	</div>
</template>

<script>
	export default {
		props: {
			value: [String, Array],
			
			type: {
				type: String,
				default: 'datetime'
			},
			
			range: Boolean,
			
			placeholder: String,
			
			defaultTime: String,
			
			limit: Array
		},

		data() {
			return {
				valueData: this.value,
				pickerOptions: {
					disabledDate: time => {
						if (this.limit && this.limit.length) {
							let min = this.limit[0] ? new Date(this.limit[0].replace(/-/g, '/')).getTime() : -Infinity,
								max = this.limit[1] ? new Date(this.limit[1].replace(/-/g, '/')).getTime() : Infinity;
							return time.getTime() < min || time.getTime() > max;
						}
					}
				}
			}
		},
		
		computed: {
			compType() {
				return `${this.type}${this.range ? 'range' : ''}`;
			},
			
			format() {
				switch (this.type) {
				case 'datetime':
					return 'yyyy-MM-dd HH:mm:ss';
					
				case 'date':
					return 'yyyy-MM-dd';
					
				case 'time':
					return 'HH:mm:ss';
				}
				
				return '';
			}
		},
		
		watch: {
			value(val) {
				this.valueData = val;
			},
			
			valueData(val) {
				this.$emit('input', val || (this.range ? [] : ''));
			}
		},
		
		methods: {
			focusHandle() {
				if (this.type == 'datetime' && !this.valueData && this.defaultTime) {
					this.valueData = new Date().format(`yyyy-MM-dd ${this.defaultTime}`);
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-datetime {
		>>> .el-date-editor {
			display: block;
			width: auto;
			
			.el-input__inner {
				height: 38px;
				border-radius: 0;
				font-size: 14px;
				transition: all .3s ease;
				
				&:focus {
					border-color: #bbb;
				}
			}
			
			.el-input__icon {
				line-height: 38px;
			}
		}
		
		>>> .el-range-editor {
			height: 38px;
			border-radius: 0;
			font-size: 0;
			transition: all .3s ease;
				
			&.is-active {
				border-color: #bbb;
			}
				
			&.el-input__inner {
				padding: 0 5px 0 10px;
			}
			
			.el-range-input {
				height: 36px;
				font-size: 14px;
				text-align: left;
			}
			
			.el-range-separator {
				height: 36px;
				line-height: 36px;
			}
			
			.el-input__icon {
				line-height: 36px;
			}
		}
	}
</style>